/*----------------------------------
- DEPENDANCES
----------------------------------*/

// Npm
import React from 'react';
import type { ComponentChild } from 'preact';

// Core
import useContext, { ClientContext } from '@/client/context';
import useHeader from '@client/pages/useHeader';

// App
import Logo from '@/client/assets/identity/logo-dark.png';
import { Button, Link } from '@client/components';
import sectorIcons from '../../platform/domains/Filters/sectorIcons';

/*----------------------------------
- TYPES
----------------------------------*/

export type Props = { 
    header?: ComponentChild | ComponentChild[],
    children?: ComponentChild | ComponentChild[],
    title: string,
    description: string,
    class?: string,
}

/*----------------------------------
- DEPENDANCES
----------------------------------*/
export default ({ 
    header: pageHeader, children,
    title, description, 
    class: className,
}: Props) => {

    /*----------------------------------
    - INIT
    ----------------------------------*/

    let { data, user, context, app, api } = useContext();

    const [openMenu, setOpenMenu] = React.useState(false);

    useHeader({ title, description });

    /*----------------------------------
    - ACTIONS
    ----------------------------------*/ 

    /*----------------------------------
    - RENDER
    ----------------------------------*/
    return <>
        <header class="row" style={{ position: 'relative' }}>

            <Button type="secondary" class="Mobile" icon="bars" shape="pill"
                onClick={() => setOpenMenu(o => !o)} />

            <nav id="Navigation" class={openMenu ? 'open' : 'HideMobile'}>
                <ul class="menu">
                    <li style={{ position: 'static' }}>
                        <Button link="/domains" iconR="angle-down">
                            Domains
                        </Button>
                        {/* <div class="menu submenu card col pos-bottom pd-0 sp-0 floating" style={{
                            left: '0px',
                            width: '100%',
                            zIndex: 100
                        }}>

                            <div class="row al-fill pd-1">


                                <ul class="col menu grid xa2 col-1 al-fill sp-05" style={{
                                    gridTemplateColumns: 'repeat(auto-fit, minmax(10rem, 1fr))'
                                }}>
                                    <Button nav link="/domains/oneword" shape="tile" class="pd-1 al-center"
                                        type="secondary">
                                        <i src="planet-ringed" /> One word Domains
                                    </Button>
                                    <Button nav link="/domains/brandable" shape="tile" class="pd-1 al-center"
                                        type="secondary">
                                        <i src="planet-ringed" /> Brandable Domains
                                    </Button>
                                    <Button nav link="/domains/short" shape="tile" class="pd-1 al-center"
                                        type="secondary">
                                        <i src="planet-ringed" /> Short Domains
                                    </Button>
                                    <Button nav link="/domains/actionnable" shape="tile" class="pd-1 al-center"
                                        type="secondary">
                                        <i src="planet-ringed" /> Actionnable Domains
                                    </Button>
                                </ul>

                                <div class="col sp-05 card minimal col-1 pdv-1 pdh-05 scrollable h-3">

                                    <strong class="txt-left pdl-05">
                                        Sectors
                                    </strong>

                                    <ul class="col menu grid xa2" style={{
                                        gridTemplateColumns: 'repeat(auto-fit, minmax(10rem, 1fr))'
                                    }}>
                                        {data.navigation.sectors.map(sector => (
                                            <Button nav link={`/domains/sector/${sector.slug}`} shape="tile" class="pd-1">
                                                <i src={sectorIcons[sector.slug]} /> {sector.name}
                                            </Button>
                                        ))}
                                    </ul>
                                </div>

                                <div class="col sp-05 card minimal col-1 pdv-1 pdh-05 scrollable h-3">

                                    <strong class="txt-left pdl-05">
                                        TLDs
                                    </strong>

                                    <ul class="col menu grid xa2" style={{
                                        gridTemplateColumns: 'repeat(auto-fit, minmax(10rem, 1fr))'
                                    }}>
                                        {data.navigation.tlds.map(tld => (
                                            <Button nav link={`/domains/tld/${tld}`}>
                                                <i src="planet-ringed" /> .{tld}
                                            </Button>
                                        ))}
                                    </ul>
                                </div>
                            </div>
                        </div> */}
                    </li>
                    {/* <Button nav link="/tools" iconR="angle-down">
                        Tools
                    </Button> */}
                    <li>
                        <Button nav link="/blog" target="_blank">
                            Guides
                        </Button>
                    </li>
                    <li>
                        <Button nav link="/blog/news" target="_blank">
                            News
                        </Button>
                    </li>
                    <li>
                        <Button nav link="/pricing">
                            Pricing
                        </Button>
                    </li>
                </ul>
            </nav>

            <Link title="Unique Domains" to="/" id="Logo">
                unique<strong class="fg primary">.</strong>
            </Link>

            <div class="Actions row al-right sp-05">
                <Button type="secondary" link="/user/login" shape="pill" class="HideMobile">
                    Login
                </Button>
                <Button type="primary" link="/user/signup" shape="pill" class="HideMobile">
                    Signup
                </Button>
                <Button type="secondary" link="/user/login" shape="pill" class="Mobile" icon="rocket" />
            </div>

        </header>

        <main class="col">
            {children}
        </main>
    </>
}